module.exports = __webpack_public_path__ + "media/images/slider-big-arrow-left-blue-ce0c9aed60e7fad61de06adbc218a636.png";